<template>
  <el-drawer
      title=""
      :visible.sync="drawerVisible"
      :direction="direction"
      :show-close="false">
    <el-form :model="form" ref="formRef" class="operate-after">
      <el-form-item class="operate-after-edit" prop="name">
        <el-input v-model="form.name"
                  type="text"
                  placeholder=""
                  maxlength="30"
                  show-word-limit/>
        <!-- 取消-->
        <div class="edit" @click="cancel()">{{$t('friends.cancel')}}</div>
      </el-form-item>
      <!-- 保存-->
      <el-button class="green-btn-sm" :disabled="disabledBtn" @click="saveData">{{$t('userinfo.save')}}</el-button>
    </el-form>
  </el-drawer>
</template>

<script>
import {
  isEmpty,
  MessageSuccess,
  MessageError
} from "@/util/util"
import {
  updateUserById
} from "@/request/requests"
export default {
  name: "editNickName",
  data(){
    return{
      drawerVisible:false,
      direction:'btt',
      form:{
        name:''
      },

    }
  },
  computed:{
    disabledBtn(){
      let flag = true;
      if(!this.isEmpty(this.form.name)){
        flag = false;
      }
      return flag;
    }
  },
  methods:{
    isEmpty,
    init(form){
      this.form.name = form.name;
      this.drawerVisible = true;
    },
    async saveData() {
      let res = await updateUserById(this.form)
      if (res.status == "200") {
        //刷新info
        this.$emit('refreshInfo');
        this.cancel();
        MessageSuccess(res.msg)
      } else {
        MessageError(res.msg)
      }
    },
    cancel(){
      this.drawerVisible = false;
      Object.assign(this.$data.form, this.$options.data().form);
      this.$nextTick(()=>{
        this.$refs['formRef'].clearValidate();
      })
    }

  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/userInfo.scss";
::v-deep .el-drawer.btt{
  height:30%!important;
}
</style>